import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AdvanceVectoringUserService } from "app/analytic/advance-vectoring-user.service";
import * as moment from "moment";
import { debounceTime, distinctUntilChanged, Subject, Subscription } from "rxjs";
import * as FileSaver from "file-saver";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "app/modules/shared/services/api.service";
import { CryptoService } from "app/shared/utils/crypto.service";

@Component({
  selector: "app-basic-vectoring-users",
  templateUrl: "./basic-vectoring-users.component.html",
  styleUrls: ["./basic-vectoring-users.component.scss"],
})
export class BasicVectoringUsersComponent implements OnInit, OnDestroy {
  // ***************SG-4637 start  *******************

  dateInfo: any;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  dateType: { type: string; from: string; to: string; count: number };
  displayedColumns: string[] = ["title", "sessionsPlayed", "clearedSessionCount", "failedCount", "percentageCompleteLesson"];
  dataSource: MatTableDataSource<any>;

  startDate: any;
  endDate: any;
  subSink: Subscription;
  @Input() dateData$: any;
  @Input() selectedApp: any;
  gameData: any;
  missionRecords: any;
  pageSize: number;
  userName: any;

  constructor(private advanceVectoringService: AdvanceVectoringUserService, private route: ActivatedRoute, private router: Router, private api: ApiService, private crypto: CryptoService) {}

  ngOnInit(): void {
    this.userName = localStorage.getItem("nickName");
    let missionData = localStorage.getItem("selectedApp");
    this.gameData = JSON.parse(missionData);
    if (JSON.parse(missionData).title == "Basic Vectoring") {
      this.dateInfo = JSON.parse(localStorage.getItem("dateRange"));
      this.subSink = this.dateData$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((next) => {
        if (next) {
          if (this.dateInfo) {
            next = this.dateInfo;
          }
          this.dateType = { type: "", from: "", to: "", count: 0 };
          this.dateType.type = next.type ? next.type.toLowerCase() : "day";
          this.dateType.from = next.from ? next.from : moment(new Date()).format("YYYY-MM-DD");
          this.dateType.to = next.to ? next.to : moment(new Date()).subtract(30, "days");
          this.dateType.count = next.count ? next.count : 30;
          this.startDate = moment(next.startDate).format("YYYY-MM-DD");
          this.endDate = moment(next.endDate).format("YYYY-MM-DD");
          this.getUserMissionData();
        }
      });
    }
  }

  async getUserMissionData() {
    let nameStr = this.crypto.isProbablyEncrypted(this.userName) ? this.userName : await this.crypto.encryptData(this.userName);
    this.advanceVectoringService
      .getUserMissionDataBasicVectoring(this.gameData.id, this.dateType.type, this.startDate, this.endDate, nameStr)
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((response: any) => {
        this.missionRecords = response;
        // this.dataSource = new MatTableDataSource<any>(this.missionRecords);
        this.dataSource = new MatTableDataSource(response);
        this.dataSource.sort = this.sort;
        this.pageSize = 5;
        this.dataSource.paginator = this.paginator;
        this.dateInfo = undefined;
      });
  }
  ngOnDestroy(): void {
    if (this.subSink) this.subSink.unsubscribe();
  }

  onPageChange(event) {}

  exportCsvData(usage) {
    this.advanceVectoringService.downloadMissiondata(this.dateType.type, this.gameData.id, this.userName).subscribe((data: any) => {
      let dataObject: any = data;
      if (data.type === "application/zip") {
        var blob = new Blob([data], { type: data.type });
        FileSaver.saveAs(blob, usage.toUpperCase() + ".zip");
      } else {
        var blob = new Blob([data], { type: "application/csv" });
        FileSaver.saveAs(blob, usage.toUpperCase() + ".csv");
      }
    });
  }
  //********************* SG-7145 start *******************
  openMission(element) {
    let missionData = localStorage.getItem("selectedApp");
    let selectedApp = JSON.parse(missionData);
    let appData = { ...selectedApp, lessonType: element.lessonType };
    localStorage.setItem("selectedApp", JSON.stringify(appData));
    //**************  SG-7218 start *****************

    this.router.navigate(["main/user/details/basic", this.userName, element.title]).then(() => {
      this.api.addRoute(0, element.title);
    });
    //**************  SG-7218 end *****************
  }
  //********************* SG-7145 end *******************
}
// ***************SG-4637 end  *******************
